module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-cell"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Tag")]), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("基础用法")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "tags-container"
  }, [_c('zan-tag', [_vm._v("返现")]), _vm._v(" "), _c('zan-tag', {
    attrs: {
      "plain": true
    }
  }, [_vm._v("返现")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tags-container"
  }, [_c('zan-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("返现")]), _vm._v(" "), _c('zan-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("四字标签")]), _vm._v(" "), _c('zan-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("一")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tags-container"
  }, [_c('zan-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("返现")]), _vm._v(" "), _c('zan-tag', {
    attrs: {
      "plain": true,
      "type": "danger"
    }
  }, [_vm._v("返现")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tags-container"
  }, [_c('zan-tag', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("返现")]), _vm._v(" "), _c('zan-tag', {
    attrs: {
      "plain": true,
      "type": "primary"
    }
  }, [_vm._v("返现")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tags-container"
  }, [_c('zan-tag', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v("返现")]), _vm._v(" "), _c('zan-tag', {
    attrs: {
      "plain": true,
      "type": "success"
    }
  }, [_vm._v("返现")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tags-container"
  }, [_c('zan-tag', {
    attrs: {
      "type": "danger",
      "mark": true
    }
  }, [_vm._v("返现")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72098bef!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/examples/tag.vue
// module id = 252
// module chunks = 0